import { createBrowserClient } from '@supabase/ssr';
import { Database } from '@/types_db';

let cachedClient: ReturnType<typeof createBrowserClient<Database>> | undefined;

export const createClient = () => {
  if (!cachedClient) {
    cachedClient = createBrowserClient<Database>(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
    );
  }
  return cachedClient;
};
